import { CONTENT_GROUP_ACTION, userConstants } from '../constants';
import { stageConstants } from '../constants/stage.constants';
import { updateStageAndItemOrder } from '../utils/reorderStageAndCards';
import { sortByField } from '../utils/sortByField';

const initialState = { stages: [], clone_stages: [], loading: false, error: '', stages_to_reload: [] };

export function stage(state = initialState, action) {
  switch (action.type) {
    case stageConstants.SET_STAGES: {

      const clone_stages = state.stages;
       
      return {
        ...state,
        stages: sortByField(action.payload.data.data, 'index', 'asc'),
        clone_stages: clone_stages
      }
    }

    case stageConstants.REVERT_STAGES: {
       
      return {
        ...state,
        stages: state.clone_stages,
        clone_stages: state.clone_stages
      }
    }


    case stageConstants.UPDATE_STAGE: {
      const updatedStage = action.payload.data.data;
      
      let newArray = state.stages;
      const existingStage = state.stages.find(stage => stage.id === updatedStage.id);
      
      if (existingStage) {
        newArray = state.stages.map(stage =>
        stage.id === updatedStage.id ? { ...stage, ...updatedStage } : stage
      );
      } else {
        newArray = [...state.stages, { ...updatedStage, items: [], page: 1 }];
      }
       
      return {
        ...state,
        stages: sortByField(newArray, 'index', 'asc'),
        clone_stages: sortByField(newArray, 'index', 'asc')
      }
    }

    case stageConstants.STAGE_SORT: {
      const sortedStageIds = action.payload.data.data.sorted_stage_ids;
      
      const newArray = state.stages.map((stage) => {
        const sortedStageIndex = sortedStageIds.findIndex((stage_id) => stage_id === stage.id);
        return { ...stage, position: sortedStageIndex !== -1 ? sortedStageIndex : stage.index };
      }); 

      return { 
        ...state,
        loading: false,
        stages: sortByField(newArray, 'index', 'asc')
      };
    }

    case userConstants.PAGE_LOADING: {
      return {
        ...state,
        loading: true
      };
    }

    case userConstants.STAGE_LOADING: {
      return {
        ...state,
        stage_loading: true
      };
    }

    case userConstants.STAGE_FAILURE: {
      return {
        ...state,
        loading: false,
        stage_loading: false,
        error:action.payload
      };
    }

    case userConstants.STAGE_REQUEST: {
      return {
        ...state,
        loading: false,
        stage_loading: false,
      };
    }

    case userConstants.GET_STAGE:{
      return{
        ...state,
        stages: action.payload.data.data,
        currentWorkspace: action.payload.data.workspace,
        loading: false,
        stage_loading: false,
      }
    }

    case userConstants.CREATE_STAGE:{
      const newStage = action.payload;

      return {
        ...state,
        stages: sortByField([...state.stages, { ...newStage, items: [], page: 1 }], 'index', 'asc'),
        loading: false,
        stage_loading: false,
      }
    }

    case userConstants.NEW_STAGE:{
      return{
        ...state,
        currentWorkspace: action.payload.data.workspace,
        loading: false,
        stage_loading: false,
      }
    }

    case userConstants.EDIT_STAGE:{
      return {
        ...state,
        editStage: action.payload.data,
        currentWorkspace: action.payload.data.workspace,
        can_access_approval_request: action.payload.data.can_access_approval_request,
        loading: false,
        stage_loading: false,
      }
    }

    case userConstants.GET_STAGE_LIST_INITIAL_DATA:{
      return {
        ...state,
        loading: false,
        stage_loading: false
      }
    }

    case userConstants.GET_CALENDAR_DATA: {
      return {
        ...state,
        loading: false,
        schedule: action.payload.data.content_groups
      }
    }
    
    case userConstants.STAGES_TO_UPDATE:{ 
      return {
        ...state,
        loading: false,
        stage_loading: false,
        stages_to_update: action.payload.data.stages
      }
    }

    case userConstants.DELETE_STAGE:{
      let id = action.payload.data.data.id
      return {
        ...state,
        stages: state.stages && state.stages.filter(item => item.id !== id),
        loading: false,
        stage_loading: false,
      }
    }

    case stageConstants.ADD_ITEM_TO_STAGE: {
      const { stage, content_group } = action.payload;
      const stageId = stage.id;

      const newArray = state.stages.map(stage => 
                            stage.id === stageId 
                              ? { ...stage, items: [content_group, ...stage.items] }
                              : stage
                        )

      return {
        ...state,
          stages: sortByField(newArray, 'index', 'asc')
      };
    }


     case stageConstants.REMOVE_ITEM_FROM_STAGE: {
      const { stage, content_group } = action.payload;
      const stageId = stage.id;

      const newArray = state.stages.map(stage => 
                            stage.id === stageId 
                              ? { ...stage, items: stage.items.filter(item => item.id !== content_group.id) }
                              : stage
                        )

      return {
        ...state,
          stages: sortByField(newArray, 'index', 'asc')
      };
    }

    case stageConstants.ADD_ITEMS_TO_STAGE: {
      const { stage, items } = action.payload;
      const stageId = stage.id;

      const newArray = state.stages.map(stage => 
                            stage.id === stageId 
                              ? { ...stage, items: [...items, ...stage.items] }
                              : stage
                        )

      return {
        ...state,
          stages: sortByField(newArray, 'index', 'asc')
      };
    }

    case stageConstants.STAGE_SORT_CARD_DUE_DATE: {
      const updated_stage = action.payload;

      const newArray = state.stages.map(stage => 
                      stage.id === updated_stage.id
                        ? { 
                            ...stage, 
                            items: sortByField(updated_stage.items, 'index', 'asc'), 
                            page: 1, 
                            total_pages: updated_stage.total_pages, 
                            has_next_page: updated_stage.has_next_page,
                          }
                        : stage
                  )

      return {
        ...state,
          stages: sortByField(newArray, 'index', 'asc')
      }
    }

    case stageConstants.STAGES_TO_RELOAD: {
      const stagesToReload = action.payload;
      return {
        ...state,
        stages_to_reload: stagesToReload
      };
    }

    case stageConstants.SORT_STAGE_AND_CARDS: {
      const updatedStages = action.payload;
      const oldStages = state.stages;
      const newArray = updateStageAndItemOrder(oldStages, updatedStages);

      return {
        ...state,
        stages: newArray,
        clone_stages: newArray // NOTE: This is done to keep the clone_stages in sync after a sort
      }
    }

    case stageConstants.UPDATE_STAGES_CARD_COUNT: {
      const stageCountMap = action.payload.reduce((map, stage) => {
      map[stage.id] = stage.content_groups_count;
        return map;
      }, {});

      return {
        ...state,
        stages: state.stages.map(stage => ({
          ...stage,
          content_groups_count: stageCountMap[stage.id] ?? stage.content_groups_count
        }))
      };
    }

    case stageConstants.REFRESH_STAGE: {
      const refreshedStage = action.payload;

      const updatedStages = state.stages.map(stage =>
          stage.id === refreshedStage.id
            ? {
                // Preserve stage index
                ...stage,
                ...refreshedStage,
                index: stage.index,
                // Preserve item indexes
                items: stage.items.length ?   
                          stage.items.map(item => {
                            const updatedItem = refreshedStage.items?.find(i => i.id === item.id);
                            return updatedItem
                              ? { ...updatedItem, index: item.index } // keep original index
                              : item;
                          })
                        : refreshedStage.items || []
              }
            : stage
        )

      return {
        stages: updatedStages,
        clone_stages: updatedStages,
      }
    }

    case userConstants.STAGE_DELETE_REQUEST: {
      const stageToDelete = action.payload.data;
      const filteredStages = state.stages.filter(stage => stage.id !== stageToDelete.id);

      return {
        ...state,
        stages: filteredStages,
        clone_stages: filteredStages,
      };
    }

    case CONTENT_GROUP_ACTION.UPDATE_CARD_ITEM_AT_LIST: {
      const card  = action.payload;

      // Find the stage containing the card and update its labels
      const newArray = state.stages.map(stage => {
        // Check if this is the stage containing our card
        if (stage.id === card.stage_id) {
          // Update the labels for the matching card
          return { 
                  ...stage, 
                  items: stage.items.map(item => 
                                              item.id === card.id 
                                                ? card
                                                : item
                                        )
                };
        }
        return stage;
      });

      return {
        ...state,
        stages: newArray
      }
    }

    case CONTENT_GROUP_ACTION.UPDATE_CONTENT_GROUP_ASSIGNED_USERS: {
      const { assigned_users, card } = action.payload;

      // Find the stage containing the card and update its assigned users
      const newArray = state.stages.map(stage => {
        // Check if this is the stage containing our card
        if (stage.id === card.stage_id) {
          // Update the assigned users for the matching card
          const updatedItems = stage.items.map(item => 
                                                      item.id === card.id 
                                                        ? { ...item, assigned_users } 
                                                        : item
                                              );              
          return { ...stage, items: updatedItems };
          }
        return stage;
      });

      return {
        ...state,
        stages: newArray
      }
    }

    case CONTENT_GROUP_ACTION.ADD_LABEL_TO_CARD: {
      const { label, card } = action.payload;

      // Find the stage containing the card and update its labels
      const newArray = state.stages.map(stage => {
        // Check if this is the stage containing our card
        if (stage.id === card.stage_id) {
          // Update the labels for the matching card
          const updatedItems = stage.items.map(item => 
                                                      item.id === card.id 
                                                        ? { ...item, labels: [
                                                                                ...item.labels.filter(l => l.id !== label.id), 
                                                                                label
                                                                             ] 
                                                          } 
                                                        : item
                                              );              
          return { ...stage, items: updatedItems };
          }
        return stage;
      });

      return {
        ...state,
        stages: newArray
      }
    }

    case CONTENT_GROUP_ACTION.UPDATE_CARD_UNREAD_COMMENTS: {
      const card = action.payload;

      // Find the stage containing the card and update its labels
      const newArray = state.stages.map(stage => {
        // Check if this is the stage containing our card
        if (stage.id === card.stage_id) {
          // Update the labels for the matching card
          return { 
                  ...stage, 
                  items: stage.items.map(item => 
                                              item.id === card.id 
                                                ? { 
                                                    ...item, 
                                                    unread_comments: card.unread_comments
                                                  } 
                                                : item
                                        )
                };
        }
        return stage;
      });

      return {
        ...state,
        stages: newArray
      }
    }

    case CONTENT_GROUP_ACTION.UPDATE_CARD_LIST_INFO: {
      const card = action.payload;

      // Find the stage containing the card and update its labels
      const newArray = state.stages.map(stage => {
        // Check if this is the stage containing our card
        if (stage.id === card.stage_id) {
          // Update the labels for the matching card
          return { 
                  ...stage, 
                  items: stage.items.map(item => 
                                              item.id === card.id 
                                                ? { 
                                                    ...item, 
                                                    completed_subtasks: card.completed_subtasks,
                                                    total_subtasks: card.total_subtasks
                                                  } 
                                                : item
                                        )
                };
        }
        return stage;
      });

      return {
        ...state,
        stages: newArray
      }
    }

    case CONTENT_GROUP_ACTION.UPDATE_CARD_STAGE_INFO: {
      const card = action.payload;

      // Find the stage containing the card and update its labels
      const newArray = state.stages.map(stage => {
        // Check if this is the stage containing our card
        if (stage.id === card.stage.id) {
          // Update the labels for the matching card
          return { 
                  ...stage, 
                  items: stage.items.map(item => 
                                              item.id === card.id 
                                                ? { 
                                                    ...item, 
                                                    stage: card.stage, 
                                                    submitted: card.submitted, 
                                                    approved: card.approved 
                                                  } 
                                                : item
                                        )
                };
        }
        return stage;
      });

      return {
        ...state,
        stages: newArray
      }
    }

    case CONTENT_GROUP_ACTION.REMOVE_LABEL_FROM_CARD: {
      const { label, card } = action.payload;

      // Find the stage containing the card and update its labels
      const newArray = state.stages.map(stage => {
        // Check if this is the stage containing our card
        if (stage.id === card.stage_id) {
          // Update the labels for the matching card
          const updatedItems = stage.items.map(item => 
                                                      item.id === card.id 
                                                        ? { 
                                                            ...item, 
                                                            labels: item.labels.filter(l => l.id !== label.id) 
                                                          } 
                                                        : item
                                              );              
          return { ...stage, items: updatedItems };
          }
        return stage;
      });

      return {
        ...state,
        stages: newArray
      }
    }
      

  default:
    return state
  }
}
